import {useConfig} from '@aboutyou/config';
import {CategoryHighlightSection as CategoryHighlightSectionType} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sections.types';
import {
  HorizontalSlider,
  HorizontalSliderHeader,
  RowSection,
  SliderPaginationBase,
  mobileOnlyLinaria,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {TextBanner} from '../../../../features/Recommendations/deprecated/shared';
import {CategoryHighlightSectionCard} from './CategoryHighlightSectionCard';

export const CategoryHighlightSection: React.FC<
  CategoryHighlightSectionType & {streamPosition: number}
> = ({streamPosition, topline, headline, elements}) => {
  const {device} = useConfig();

  return (
    <RowSection>
      <StyledHorizontalSlider
        dataTestId="categoryHighlightSection"
        disableHeaderControl={device === 'mobile'}
        SlideControlComponent={SliderPaginationBase}
        hideSideButtons
        constrained={device === 'desktop'}
        title={<StyledTextBanner headline={headline} subline={topline} />}
        slideCount={1.3}
        slideCountSmall={2.5}
        slideCountMedium={4}
        uniqueKey={`categorySection-${streamPosition}`}
      >
        {elements.map((element, index) => (
          <CategoryHighlightSectionCard
            key={index}
            horizontalPosition={index}
            element={element}
            streamPosition={streamPosition}
          />
        ))}
      </StyledHorizontalSlider>
    </RowSection>
  );
};

const StyledTextBanner = styled(TextBanner)`
  ${mobileOnlyLinaria(`margin-left: 16px;`)}
`;

const StyledHorizontalSlider = styled(HorizontalSlider)`
  ul {
    gap: 3px;
  }

  ${tabletAndUpLinaria(`
    ul {
      padding-left: 0;
      margin-top: 24px;
      gap: unset;
    }
  `)}

  ${HorizontalSliderHeader} {
    margin: 0;
  }
`;
